export const CENTRAL_FUNCTIONS = [
  "DDaT",
  "Finance",
  "National Communications",
  "Supply Chain Operations",
  "System Operator - Capacity Planning",
];
export const CENTRAL_FUNCTIONS_GBRTT = ["GBRTT"];
